import { facadeApi } from 'api'

export const cancelUploadFileApi = (fileId: string) => {
  return facadeApi.post<''>(`/file-manager/v1/files/${fileId}/cancel-upload`)
}
